import type {
  CreateSurveyQuestionFormValues,
  SurveyAnswerType,
  SurveyQuestionType,
  SurveyStatus,
} from '../types/survey.types';

export const SURVEY_LIST_PAGE_SIZE = 20;

export const SURVEY_SUBMISSION_LIST_PAGE_SIZE = 20;

export const SURVEY_CHOICE_QUESTION_TYPES: readonly SurveyQuestionType[] = [
  'mcq',
  'dropdown',
  'checkbox',
];

export const SURVEY_NUMERIC_ANSWER_TYPES: readonly SurveyAnswerType[] = [
  'number',
  'decimal',
  'percentage',
];

export const SURVEY_TITLE_MAX_LENGTH = 150;
export const SURVEY_DESCRIPTION_MAX_LENGTH = 1000;
export const SURVEY_QUESTION_TEXT_MAX_LENGTH = 500;
export const SURVEY_OPTION_TEXT_MAX_LENGTH = 200;

export const SURVEY_RATING_DEFAULT_MIN = 1;
export const SURVEY_RATING_DEFAULT_MAX = 5;

export const SURVEY_RATING_SCALE = Array.from(
  { length: SURVEY_RATING_DEFAULT_MAX - SURVEY_RATING_DEFAULT_MIN + 1 },
  (_, index) => SURVEY_RATING_DEFAULT_MIN + index,
);

export const SURVEY_QUESTION_TYPE_CHANGE_WARNING =
  'Changing type will clear existing options and answer settings.';

export const INITIAL_SURVEY_QUESTION: CreateSurveyQuestionFormValues = {
  text: '',
  type: 'text',
  isRequired: false,
};

export const SURVEY_STATUS_LABELS: Record<SurveyStatus, string> = {
  draft: 'Draft',
  active: 'Active',
  expired: 'Expired',
};

export const SURVEY_QUESTION_TYPE_LABELS: Record<SurveyQuestionType, string> = {
  text: 'Text',
  mcq: 'Multiple Choice',
  dropdown: 'Dropdown',
  checkbox: 'Checkbox',
  rating: 'Rating',
};

export const SURVEY_ANSWER_TYPE_LABELS: Record<SurveyAnswerType, string> = {
  text: 'Text',
  number: 'Number',
  decimal: 'Decimal',
  percentage: 'Percentage',
};

export const SURVEY_TEXT_PLACEHOLDER_BY_ANSWER_TYPE: Record<SurveyAnswerType, string> = {
  text: 'User will enter text…',
  number: 'User will enter a number',
  decimal: 'User will enter a decimal',
  percentage: 'User will enter a percentage',
};

export const SURVEY_ANSWER_DEFAULT_PLACEHOLDER = 'Enter your answer';

export const SURVEY_ANSWER_PLACEHOLDER_BY_ANSWER_TYPE: Record<SurveyAnswerType, string> = {
  text: 'Enter your answer',
  number: 'Enter a number',
  decimal: 'Enter a decimal',
  percentage: 'Enter a percentage (0–100)',
};

export const SURVEY_PERCENTAGE_MIN = 0;
export const SURVEY_PERCENTAGE_MAX = 100;

export const SURVEY_RESPONDENT_VIEW_MODES = ['by-day', 'by-question'] as const;
export type SurveyRespondentViewMode = (typeof SURVEY_RESPONDENT_VIEW_MODES)[number];

export const SURVEY_RESPONDENT_VIEW_MODE = {
  BY_DAY: 'by-day',
  BY_QUESTION: 'by-question',
} as const satisfies Record<string, SurveyRespondentViewMode>;

export const SURVEY_RESPONDENT_VIEW_MODE_LABELS: Record<SurveyRespondentViewMode, string> = {
  [SURVEY_RESPONDENT_VIEW_MODE.BY_DAY]: 'By day',
  [SURVEY_RESPONDENT_VIEW_MODE.BY_QUESTION]: 'By question',
};
